/* eslint-disable guard-for-in */
import axios from 'axios';

// keys for actiontypes
export const ActionTypes = {

  // books
  FETCH_BOOKS: 'FETCH_BOOKS',
  FETCH_BOOK: 'FETCH_BOOK',
  CREATE_BOOK: 'CREATE_BOOK',

  // chapters
  FETCH_CHAPTERS: 'FETCH_CHAPTERS',
  FETCH_CHAPTER: 'FETCH_CHAPTER',
  CREATE_CHAPTER: 'CREATE_CHAPTER',

  // pages
  FETCH_PAGES: 'FETCH_PAGES',
  FETCH_PAGE: 'FETCH_PAGE',
  CREATE_PAGE: 'CREATE_PAGE',
  DELETE_PAGE: 'DELETE_PAGE',

  // notebook

  FETCH_NOTEBOOK: 'FETCH_NOTEBOOK',
  PATCH_NOTEBOOK: 'PATCH_NOTEBOOK',
  UPDATE_NOTEBOOK: 'UPDATE_NOTEBOOK',

  // personal note
  CREATE_PERSONALNOTE: 'CREATE_PERSONALNOTE',
  FETCH_PERSONALNOTES: 'FETCH_PERSONALNOTES',
  FETCH_PERSONALNOTE: 'FETCH_PERSONALNOTE',
  DELETE_PERSONALNOTE: 'DELETE_PERSONALNOTE',
  UPDATE_PERSONALNOTE: 'UPDATE_PERSONALNOTE',

  // reactions + comments
  FETCH_REACTIONS: 'FETCH_REACTIONS',
  FETCH_REACTION: 'FETCH_REACTION',
  CREATE_REACTION: 'CREATE_REACTION',
  FETCH_COMMENTS: 'FETCH_COMMENTS',

  // user
  AUTH_USER: 'AUTH_USER',
  DEAUTH_USER: 'DEAUTH_USER',
  AUTH_ERROR: 'AUTH_ERROR',
  FETCH_USER: 'FETCH_USER',

  // other
  FETCH_AUTHOR: 'FETCH_AUTHOR',
  AUTHOR_SAVE_ERROR: 'AUTHOR_SAVE_ERROR',
  LINK: 'LINK',
  FETCH_CONTRIBUTORS: 'FETCH_CONTRIBUTORS',
  FETCH_PAGES_BY_USER: 'FETCH_PAGES_BY_USER',

};

export const ROOT_URL = 'https://our-stories-api.herokuapp.com/api';
// export const ROOT_URL = 'http://localhost:9090/api';

// BOOKS

export function fetchBooks() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_BOOKS, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function fetchBook(id) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${id}`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_BOOK, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function createBook(book, history) {
  return (dispatch) => {
    axios.post(`${ROOT_URL}/books`, book, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.CREATE_BOOK, payload: response.data });
        history.push('/');
      });
  };
}

export function updateBook(book) { /* axios put */
  axios.put(`${ROOT_URL}/books/${book.id}`, book, { headers: { authorization: localStorage.getItem('token') } }).then(fetchBook(book.id));
}

export function deleteBook(id, history) { /* axios delete */
  axios.delete(`${ROOT_URL}/books/${id}`, { headers: { authorization: localStorage.getItem('token') } }).then(() => history.push('/'));
}

// CHAPTERS

export function fetchChapters(bId) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${bId}/chapters`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_CHAPTERS, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function createChapter(bId, chapter, history) {
  return (dispatch) => {
    axios.post(`${ROOT_URL}/books/${bId}/chapters`, chapter, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.CREATE_CHAPTER, payload: response.data });
        history.push(`/books/${bId}/chapters`);
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function fetchChapter(bId, chId) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${bId}/chapters/${chId}`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_CHAPTER, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

// PAGES

export function searchPages(query) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/search/?find=${query}`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_PAGES, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function fetchPages(bId, chId) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_PAGES, payload: response.data });
    }).catch((error) => {
      console.log('fetch pages error');
    });
  };
}

export function fetchPagesByUser(userID) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/profile/${userID}/pages`, { headers: { authorization: localStorage.getItem('token') } }).then((response) => {
      dispatch({ type: ActionTypes.FETCH_PAGES_BY_USER, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function fetchPage(bId, chId, pId) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages/${pId}`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_PAGE, payload: response.data });
    }).catch((error) => {
      console.log('fetch page error');
    });
  };
}

export function createPage(bId, chId, page, history) {
  return (dispatch) => {
    axios.post(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages`, page, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.CREATE_PAGE, payload: response.data });
        history.push(`/books/${bId}/chapters/${chId}/pages`);
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function updatePage(bId, chId, pId, page, history) {
  return (dispatch) => {
    axios.put(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages/${pId}`, page, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_PAGE, payload: response.data });
        history.push(`/books/${bId}/chapters/${chId}/pages/${pId}`);
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function deletePage(bId, chId, pId, history) {
  return (dispatch) => {
    axios.delete(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages/${pId}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.DELETE_PAGE, payload: response.data });
        history.push(`/books/${bId}/chapters/${chId}/pages`);
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

// NOTEBOOK

export function fetchNotebook() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/notebook`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_NOTEBOOK, payload: response.data });
      }).catch((error) => {

      });
  };
}

export function createPersonalNote(pageID) {
  return (dispatch) => {
    axios.post(`${ROOT_URL}/notebook/collections/`, { pageID }, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        if (response.data) {
          dispatch({ type: ActionTypes.CREATE_PERSONALNOTE, payload: response.data });
        }
      });
  };
}

export function fetchPersonalNotes() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/notebook/collections`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_PERSONALNOTES, payload: response.data });
      }).catch((error) => {

      });
  };
}

export function fetchPersonalNote(id) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/notebook/collections/${id}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_PERSONALNOTE, payload: response.data });
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function fetchPersonalNotebyPage(bId, chId, pId) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/books/${bId}/chapters/${chId}/pages/${pId}/personalNote`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        if (response.data) {
          dispatch({ type: ActionTypes.FETCH_PERSONALNOTE, payload: response.data });
        }
      }).catch((error) => {

      });
  };
}

export function updateNotebook(notebook) {
  const setVersion = new Set(notebook.Queue);
  // eslint-disable-next-line no-param-reassign
  notebook.Queue = Array.from(setVersion);

  return (dispatch) => {
    axios.put(`${ROOT_URL}/notebook/`, notebook, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.UPDATE_NOTEBOOK, payload: response.data });
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function patchNotebook(pageID) {
  return (dispatch) => {
    axios.patch(`${ROOT_URL}/notebook/`, pageID, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.PATCH_NOTEBOOK, payload: response.data });
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function updatePersonalNote(id, postfields) {
  return (dispatch) => {
    axios.put(`${ROOT_URL}/notebook/collections/${id}`, postfields, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.UPDATE_PERSONALNOTE, payload: response.data });
      })
      .catch((error) => {
        console.log('update personal note error');
      });
  };
}

export function deletePersonalNote(id) {
  return (dispatch) => {
    axios.delete(`${ROOT_URL}/notebook/collections/${id}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.DELETE_PERSONALNOTE, payload: response.data });
        fetchPersonalNotes();
      })
      .catch((error) => {
        console.log('delete personal note error');
      });
  };
}

// SIGN-IN

// deletes token from localstorage
// and deauths
export function signoutUser(history) {
  return (dispatch) => {
    localStorage.removeItem('token');
    dispatch({ type: ActionTypes.DEAUTH_USER });
    history.push('/');
  };
}

// trigger to deauth if there is error
// can also use in your error reducer if you have one to display an error message
export function authError(error) {
  return {
    type: ActionTypes.AUTH_ERROR,
    message: error,
  };
}

export function signinUser(email, password, history) {
  // takes in an object with email and password (minimal user object)
  // returns a thunk method that takes dispatch as an argument (just like our create post method really)
  // does an axios.post on the /signin endpoint
  // on success does:
  return ((dispatch) => {
    return axios.post(`${ROOT_URL}/signin`, { email, password }).then((response) => {
      dispatch({ type: ActionTypes.AUTH_USER });
      localStorage.setItem('token', response.data.token);
      history.push('/');
    })
      .catch((error) => {
        console.log(error.response.data);
        dispatch(authError(`Sign In Failed. ${error.response.data.error}`));
      });
  });
}

export function signupUser(name, username, email, password, history) {
  return ((dispatch) => {
    return axios.post(`${ROOT_URL}/signup`, {
      name, username, email, password,
    }).then((response) => {
      dispatch({ type: ActionTypes.AUTH_USER });
      localStorage.setItem('token', response.data.token);
      history.push('/myprofile/init');
    })
      .catch((error) => {
        return dispatch(authError(`Sign Up Failed. ${error.response.data.error}`));
      });
  });
}

// MISC
export function setLink(link) {
  return { type: ActionTypes.LINK, payload: link };
}

export function getContributors() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/contributors`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_CONTRIBUTORS, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function fetchAuthor() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/author`, { headers: { authorization: localStorage.getItem('token') } }).then((response) => {
      if (response.data) dispatch({ type: ActionTypes.FETCH_AUTHOR, payload: response.data });
    }).catch((error) => {
    });
  };
}

export function updateAuthorPage(content) {
  return (dispatch) => {
    axios.put(`${ROOT_URL}/author`, content, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_AUTHOR, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ActionTypes.AUTHOR_SAVE_ERROR, payload: error.response.data.error });
      });
  };
}

export function fetchUserByID(userID) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/profile/${userID}`).then((response) => {
      dispatch({ type: ActionTypes.FETCH_USER, payload: response.data });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  };
}

export function fetchReactions(pageID) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/reactions/page/${pageID}`)
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_REACTIONS, payload: response.data });
      }).catch((error) => {
      });
  };
}
export function createReactions(pageID, emoji) {
  return (dispatch) => {
    axios.post(`${ROOT_URL}/reactions/page/${pageID}`, { type: emoji, pageID }, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_REACTIONS, payload: response.data });
      }).catch((error) => {
        console.log(error.response.data.error);
      });
  };
}

export function fetchComments(pageID) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/comments/page/${pageID}`)
      .then((response) => {
        dispatch({ type: ActionTypes.FETCH_COMMENTS, payload: response.data });
      }).catch((error) => {
        console.log('error in comments');
        console.log(error.response.data.error);
      });
  };
}

export function createComment(content, pageID) {
  return axios.post(`${ROOT_URL}/comments/page/${pageID}`, { content, pageID }, { headers: { authorization: localStorage.getItem('token') } })
    .then((response) => {
      return true;
    }).catch((error) => {
      console.log(error.response.data.error);
      return false;
    });
}

export function updateComment(content, commentID) {
  return axios.put(`${ROOT_URL}/comments/${commentID}`, { content }, { headers: { authorization: localStorage.getItem('token') } })
    .then((response) => {
      return true;
    }).catch((error) => {
      console.log(error.response.data.error);
      return false;
    });
}

export function deleteComment(commentID) { /* axios delete */
  return axios.delete(`${ROOT_URL}/comments/${commentID}`, { headers: { authorization: localStorage.getItem('token') } })
    .then(() => (true))
    .catch(() => (false));
}
